
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import { useCallback, useRef, useState } from 'react';
import Layout from '../../components/Layout';
import Select from '../../components/Select/Select';
import { Namespace } from '../../enums/namespaces';
import {
  basicSEO,
  createFormSchema,
  createRedirectIfNeeded,
  notEmptyRule,
  Permalink,
  resetForm,
  sortAlphabetically,
  validateForm,
} from '../../helpers';
import { TheatreBase } from '../../typings/api';
import { StaticPathParams } from '../../typings/staticPaths';
import styles from './index.module.scss';
import { useRouter } from 'next/router';
import { withForcePlanToLoggedInUnsubs } from 'context';
import classNames from 'classnames';
import Head from 'next/head';
import { useLang } from 'context/langContext';
import { authorizeUserServerSide } from 'api/firebaseAdmin';

interface Props {
  theatres: TheatreBase[];
  countryCode: string;
}

const DonateList: NextPage<Props> = ({ theatres, countryCode }) => {
  const { t } = useTranslation(Namespace.Theaters);
  const [selected, setSelected] = useState<number>(theatres[0].id);
  const ref = useRef<HTMLFormElement>(null);
  const router = useRouter();
  const { locale } = useLang();

  const RULE_NOT_EMPTY = t('common:form.not_empty');

  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    event.stopPropagation();

    const formSchema = createFormSchema({ theatre: notEmptyRule(RULE_NOT_EMPTY) });
    const validateObject = {
      theatre: selected,
    };

    const isValid = validateForm(formSchema, validateObject, ref.current);
    if (isValid) {
      router.push(
        Permalink.donateTheatre(
          theatres.find((t) => t.id === selected),
          locale,
        ),
      );
    }

    resetForm(ref.current);
  };

  const getTheater = useCallback(() => theatres?.find((tt) => tt.id === selected), [selected, theatres]);

  const getSrcTheatre = useCallback(() => {
    if (selected) {
      const theatre = getTheater();
      const theatreImg = theatre?.poster_url;
      return theatreImg ?? 'empty';
    }
    return '';
  }, [selected, theatres]);

  return (
    <Layout countryCode={countryCode}>
      <Head>{basicSEO(t('seo:donate_home_title'), t('seo:donate_description'))}</Head>
      <main className={[styles.donate, styles.donateSelect].join(' ')}>
        <div className={styles.donateWrapper}>
          <div className={classNames(styles.imagePlaceholder, getSrcTheatre() === 'empty' ? styles.withoutLogo : '')}>
            {getSrcTheatre() === 'empty' ? (
              getTheater()?.name?.substr(0, 1)
            ) : (
              <img src={getSrcTheatre()} alt={getTheater()?.name} />
            )}
          </div>
          <h1>{t('choose_donate')}</h1>
          <form ref={ref} method="POST" id="select-theater-form">
            <label>
              {t('theatre')}
              <Select
                defaultLabel={t('choose_theatre')}
                name={'theatre'}
                onChange={(val) => setSelected(+val)}
                options={theatres?.map((tt) => ({ label: tt.name, value: tt.id.toString() }))}
              />
              <span></span>
            </label>
            <button onClick={onSubmit} className="btn btn-primary">
              {t('continue')}
            </button>
          </form>
        </div>
      </main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { apiClient, locale, countryCode } = await authorizeUserServerSide(ctx);

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  const theatres = (await apiClient.getTheatres()).filter((t) => t.donations_allowed);

  return {
    props: { theatres: sortAlphabetically(theatres ?? [], 'name'), countryCode },
  };
}

export default withForcePlanToLoggedInUnsubs(DonateList);


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/donate/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  